import React, {useState} from 'react';
import {Button, CustomInput, FormGroup, Label} from 'reactstrap';
import FormHook from '../../util/FormHook/FormHook';
import {connect} from 'react-redux';
import {registerDispatch} from '../../actions/util';
import {loginUserRetireeAction} from '../../actions/user';

const ManageLogin = ({loginUserRetireeAction, history}) => {
  const [rememberMe, setRememberMe] = useState(!!localStorage.getItem('rememberMeRetiree'));

  return (
    <FormHook
      submit={(values) => {
        loginUserRetireeAction(values.username, values.password, rememberMe, history);
      }}
      defaultValues={rememberMe ? { username: localStorage.getItem('userRetiree') || '', password: '' } : {}}
      className="col-12 col-sm-6 offset-sm-3 col-md-4 offset-md-4 mt-4"
    >
      <h4>ELI Registration</h4>
      <FormGroup className="mt-2">
        <Label>Username</Label>
        <input name="username" required />
      </FormGroup>
      <FormGroup>
        <Label>Password</Label>
        <input type="password" name="password" required />
      </FormGroup>
      <FormGroup>
        <CustomInput
          type="checkbox"
          id="rememberMe"
          label="Remember me"
          inline
          checked={rememberMe}
          onChange={(e) => setRememberMe(e.target.checked)}
        />
      </FormGroup>
      <div style={{ alignItems: 'center' }}>
        <Button color="primary" size="sm">Sign in</Button>
      </div>
    </FormHook>
  );
};

const mapDispatchProps = dispatch => {
  registerDispatch(dispatch);
  return { loginUserRetireeAction };
};

export default connect(null, mapDispatchProps)(ManageLogin);
